import request from '@/utils/request'
const API = '/api/files_201_personnel'

export function Files201Personnel(params = {}, method = 'get', subpath) {
  var url = params.id ? API + '/' + params.id : API
  url = subpath ? url + '/' + subpath : url
  return request({
    url: url,
    method: method,
    params
  })
}
